class ClLoadMore extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('[data-load-more]');

    button?.addEventListener('click', () => {
      const cards = Array.from(this.querySelectorAll('.cl-review'));
      const isMobile = window.matchMedia('(max-width: 47.999rem)').matches;
      const step = Number(isMobile ? this.dataset.mobileStep ?? 3 : this.dataset.step ?? 9);
      const hiddenCards = cards.filter((card, index) => (
        isMobile
          ? index >= 3 && !card.classList.contains('is-mobile-revealed')
          : card.hidden
      ));
      const revealedCards = hiddenCards.slice(0, step);

      revealedCards.forEach((card) => {
        card.removeAttribute('hidden');
        if (isMobile) card.classList.add('is-mobile-revealed');
      });

      const firstRevealed = revealedCards[0];
      if (firstRevealed) {
        firstRevealed.tabIndex = -1;
        firstRevealed.focus({ preventScroll: false });
      }

      const status = this.querySelector('[data-load-status]');
      if (status) {
        status.textContent = (this.dataset.statusTemplate ?? '%count%').replace(
          '%count%',
          String(revealedCards.length),
        );
      }

      if (hiddenCards.length <= step) button.closest('.cl-actions')?.remove();
    });
  }
}

customElements.get('cl-load-more') || customElements.define('cl-load-more', ClLoadMore);
